// 自身のアセット
import 'PackWerkNurikaeSite/pages/companies/index/partials/company_card/component.scss'
import 'PackWerkNurikaeSite/pages/companies/index/partials/company_card/images/tel_icon.svg'
// 子コンポーネント
import 'PackWerkNurikaeSite/pages/companies/index/partials/company_card/image_and_info/component'

// ホバーアニメーション処理
document.addEventListener('mouseover', (event) => {
  const companyLink = event.target.closest('.js-company-link')
  if (companyLink) {
    companyLink.classList.add('is-current')
  }
})

document.addEventListener('mouseout', (event) => {
  const companyLink = event.target.closest('.js-company-link')
  if (companyLink) {
    companyLink.classList.remove('is-current')
  }
})
